var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRsdLower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 32V36H8V32H40ZM40 16H8V36C5.85996 36 4.11211 34.3194 4.00488 32.2061L4 32V16C4 13.7909 5.79086 12 8 12H40L40.2061 12.0049C42.3194 12.1121 44 13.86 44 16V32L43.9951 32.2061C43.8913 34.2512 42.2512 35.8913 40.2061 35.9951L40 36V16Z",
    fill: "#C9C9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3577 29.3692C50.3577 28.6099 50.9617 28 51.6988 28H52.3018C53.0389 28 53.643 28.6099 53.643 29.3692V45.5912L57.2848 41.8819L57.2862 41.8804C57.8092 41.3502 58.6555 41.3482 59.1794 41.8818L59.6074 42.3176C60.1301 42.852 60.132 43.7199 59.6061 44.2555L52.0004 52L44.3939 44.2563L44.3925 44.2549C43.8699 43.7204 43.8679 42.8525 44.3938 42.317L44.8218 41.8812C45.3447 41.351 46.1911 41.349 46.715 41.8825L50.3577 45.5917V29.3692Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsdLower);
export default __webpack_public_path__ + "static/media/rsd-lower.46d5299902f07ad19bcdd05067de7f66.svg";
export { ForwardRef as ReactComponent };